module.exports = __webpack_public_path__ + "img/pic_xiaomistepthreetwo.943d1bcb.png";